export default "__VITE_ASSET__RHxTn46___"